import React from 'react';
import './UnitCard.css';

const UnitCard = ({ unit, index, onEdit, onDelete, onDuplicate, canEdit = true }) => {
    if (!unit) return null;

    const occupancy = unit.occupancy || {};
    const inventory = unit.inventory || {};
    const pricing = unit.pricing || {};

    const getUnitTypeLabel = (type) => {
        if (!type) return 'Unit';

        return type.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const getBookingTypeLabel = (type) => {
        if (!type) return 'Private';

        return type.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const getPrice = () => {
        if (pricing.total) {
            return pricing.total;
        }

        if (pricing.actual) {
            return pricing.actual;
        }

        return null;
    };

    const price = getPrice();

    return (
        <div className='unit-card'>
            {/* =====================================================
                IMAGE
            ===================================================== */}

            <div className='unit-card-image'>
                {unit.images?.length > 0 ? (
                    <img src={unit.images[0]?.url || unit.images[0]} alt={unit.name || 'Accommodation unit'} />
                ) : (
                    <div className='unit-image-placeholder'>
                        <span>🏕️</span>
                    </div>
                )}

                {unit.active === false && <span className='unit-inactive-badge'>Inactive</span>}
            </div>

            {/* =====================================================
                CONTENT
            ===================================================== */}

            <div className='unit-card-content'>
                {/* Header */}

                <div className='unit-card-header'>
                    <div className='unit-title-area'>
                        <span className='unit-number'>Unit {index + 1}</span>

                        <h3>{unit.name || 'Unnamed Unit'}</h3>
                    </div>

                    <span className='unit-type-badge'>{getUnitTypeLabel(unit.unitType)}</span>
                </div>

                {/* Description */}

                {unit.description && <p className='unit-description'>{unit.description}</p>}

                {/* =================================================
                    UNIT DETAILS
                ================================================= */}

                <div className='unit-details'>
                    {/* Guests */}

                    <div className='unit-detail'>
                        <span className='unit-detail-icon'>👥</span>

                        <div>
                            <small>Guests</small>

                            <strong>{occupancy.maxGuests || unit.maxGuests || '—'}</strong>
                        </div>
                    </div>

                    {/* Bedrooms */}

                    <div className='unit-detail'>
                        <span className='unit-detail-icon'>🛏️</span>

                        <div>
                            <small>Bedrooms</small>

                            <strong>{unit.bedrooms || 0}</strong>
                        </div>
                    </div>

                    {/* Bathrooms */}

                    <div className='unit-detail'>
                        <span className='unit-detail-icon'>🚿</span>

                        <div>
                            <small>Bathrooms</small>

                            <strong>{unit.bathrooms || 0}</strong>
                        </div>
                    </div>

                    {/* Inventory */}

                    <div className='unit-detail'>
                        <span className='unit-detail-icon'>🏠</span>

                        <div>
                            <small>Units</small>

                            <strong>{inventory.totalUnits || unit.totalUnits || 1}</strong>
                        </div>
                    </div>
                </div>

                {/* =================================================
                    TAGS
                ================================================= */}

                <div className='unit-tags'>
                    <span className='unit-tag'>{getBookingTypeLabel(unit.bookingType)}</span>

                    {unit.bhkType && <span className='unit-tag'>{unit.bhkType}</span>}

                    {unit.sizeSqft > 0 && <span className='unit-tag'>{unit.sizeSqft} sq.ft</span>}

                    {unit.view && <span className='unit-tag'>{unit.view}</span>}
                </div>

                {/* =================================================
                    BOTTOM
                ================================================= */}

                <div className='unit-card-bottom'>
                    {/* Price */}

                    <div className='unit-price'>
                        {price ? (
                            <>
                                <span>₹{Number(price).toLocaleString('en-IN')}</span>

                                <small>/ {pricing.unit?.replace(/_/g, ' ') || 'night'}</small>
                            </>
                        ) : (
                            <span className='price-not-set'>Price not set</span>
                        )}
                    </div>

                    {/* Actions */}

                    {canEdit && (
                        <div className='unit-actions'>
                            <button
                                type='button'
                                className='unit-action-button'
                                title='Duplicate unit'
                                onClick={() => onDuplicate?.(unit, index)}
                            >
                                Duplicate
                            </button>

                            <button
                                type='button'
                                className='unit-action-button primary'
                                onClick={() => onEdit?.(unit, index)}
                            >
                                Edit
                            </button>

                            <button
                                type='button'
                                className='unit-action-button danger'
                                title='Delete unit'
                                onClick={() => onDelete?.(unit, index)}
                            >
                                Delete
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UnitCard;
